import React from "react";
import { Button, Col, Grid, Row, Stack, Text } from "rsuite";
import FlowProgressIndicator from "../user-feedback/FlowProgressIndicator";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentStep, selectFlowSteps, selectNextStepPath, selectOriginPath, selectPrevStepPath } from "../../store/slices/flow/flowSelectors";
import { resetStepState, setCurrentStep, setStepCompletedStatus } from "../../store/slices/flow/flowSlice";
import usePlaceNavigate from "../../hooks/usePlaceNavigate";

const FlowPageLayout = ({
    children, 
    title, 
    subtitle,
    onNext = async () => { return true; },
    onBack = async () => { return true; },
    nextButtonText = "CONTINUE", 
    backButtonText = "BACK", 
    hideNextButton = false, 
    hideBackButton = false, 
}) => {
    const dispatch = useDispatch();
    const placeNavigate = usePlaceNavigate();
    const selectedSteps = useSelector(selectFlowSteps);
    const selectedCurrentStep = useSelector(selectCurrentStep);
    const selectedNextStepPath = useSelector(selectNextStepPath);
    const selectedPrevStepPath = useSelector(selectPrevStepPath);
    const selectedOriginPath = useSelector(selectOriginPath);

    const goToPrevStep = (e) => {
        e.target.blur();
        if (!onBack()) return;
        let prevPath = "/" + selectedPrevStepPath;
        if (selectedCurrentStep <= 1) {
            prevPath = selectedOriginPath;
            dispatch(resetStepState());
        } else {
            dispatch(setStepCompletedStatus({stepNum: selectedCurrentStep, status: false}))
            dispatch(setCurrentStep(selectedCurrentStep - 1));
        }
        placeNavigate(prevPath);
    }

    const goToNextStep = async (e) => {
        e.target.blur()
        if (!await onNext()) return;
        dispatch(setStepCompletedStatus({stepNum: selectedCurrentStep, status: true}));
        dispatch(setCurrentStep(selectedCurrentStep + 1)); 
        placeNavigate('/' + selectedNextStepPath);
    }
    
    return (
        <Grid className="mt-24 sm-mt-0 pv-24 sm-pb-0" fluid>
            <Row role="presentation">
                <Col  role="presentation" className="flow-page-horizontal-progress-indicator" xs={24} lgHidden={true} xlHidden={true} xxlHidden={true}>
                    {
                        selectedSteps != null &&
                        <FlowProgressIndicator
                            indicatorState={selectedSteps}
                            direction="horizontal"
                            currentStateIndex={selectedCurrentStep}
                        />  
                    
                }        
                </Col>
            </Row >
            <Row>
                <Col className="flow-page-layout-container" xs={24} lg={16}>
                    
                    
                        <div className="flow-page-layout-panel-left">

                            <Text className="header-text-h3 mb-24" style={{ marginLeft: "-3px" }}>{title}</Text>
                            { subtitle?.length > 0 && <Text className="mb-24">{subtitle}</Text> }
                            <div className="content-section">
                                {children}
                            </div>
                        </div>
                    
                    
                        <Grid fluid>
                            <Row className="mv-24">
                                <Stack role="cell" className="flow-page-layout-button-back-container flow-page-layout-panel-left" direction="row">
                                {
                                    !hideNextButton &&
                                    <Button
                                        className="btn-primary mv-4 mr-16"
                                        onClick={goToNextStep}
                                    >
                                        {nextButtonText}
                                    </Button>
                                }
                                {
                                    !hideBackButton &&
                                    <Button
                                        className="btn-tertiary mv-4"
                                        onClick={goToPrevStep}
                                    >
                                        {backButtonText}
                                    </Button>
                                }
                                </Stack>                                
                            </Row>
                        </Grid>

                </Col>
                <Col lg={8} xsHidden={true} smHidden={true} mdHidden={true} className="flow-page-layout-panel-right">
                    { !!selectedSteps &&
                        <FlowProgressIndicator
                            indicatorState={selectedSteps}
                            currentStateIndex={selectedCurrentStep - 1}
                        />
                    }
                </Col>
            </Row>
        </Grid>
    )
}

export default FlowPageLayout;